import React, { useState } from 'react';
// import DocUploadModal from '../../../views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
import DynamicDocUploadModal from '../../views/pages/manage/common/fileUpload/DynamicDocUploadModal';
import { saveFileData } from './utils';
import AButton from '../../views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as UploadIcon } from "assets/img/svg/fi_upload.svg";
import { EMPTY_FILTER_FORM } from './constants';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';


const UploadTransferFile = ({
    bulkPaymentTransferProcessTag,
    setLoading,
    getBulkTransferRequestsList,
    paymentModeDropdown
}) => {

    const [isUploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [paymentType, setPaymentType] = useState("");

  const handleSaveUpload = async (allFilesData) => {
        try {
            debugger
            setLoading(true);
            // allFilesData is an object with each file's details
            // Example: { transferFile: { s3Key, fileName, fieldName, label, isMandatory }, supportingFile: {...} }
            const resp = await saveFileData(allFilesData, paymentType, bulkPaymentTransferProcessTag);
            if(resp?.code === 200){
                setUploadDialogOpen(false);
                successToast(resp?.message);
                getBulkTransferRequestsList({pageNo : 0 , filters : EMPTY_FILTER_FORM})
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);

        }
    }


    return (
        <div>

            <AButton
                variant='primary_filled'
                size='xs'
                onClick={() => setUploadDialogOpen(true)}
            >
                <UploadIcon className='mr-2'/>
                Upload Template
            </AButton>

          
            <DynamicDocUploadModal
                open={isUploadDialogOpen}
                setOpen={setUploadDialogOpen}
                saveHandler={(allFilesData) => {
                    handleSaveUpload(allFilesData)
                }}
                acceptedFileTypes={[".csv", ".xls"]}
                maxUploadFileSize={5}
                serviceName={"PAYMENT_TRANSFER_BULK_UPLOAD"}
                isBulkCollection={true}
                uniqueKeyParameter={"bulkPaymentTransferFile"}
                modalTitle={"Upload Transaction file"}
                key={isUploadDialogOpen}
                paymentMode={paymentType}
                propStyle={{ overflow: 'auto', maxWidth: '325px' }}
                fileUploads={[
                    {
                        label: "Transaction File*",
                        fieldName: "paymentTransferFile",
                        uploadLabel: "Upload Transaction File",
                        uploadedFileS3Key: "",
                        uploadedFileName: "",
                        isMandatory: true,
                        acceptedFileTypes: [".csv", ".xls"]
                    },
                    {
                        label: "Supporting File*",
                        fieldName: "supportingFile",
                        uploadLabel: "Upload Supporting File",
                        uploadedFileS3Key: "",
                        uploadedFileName: "",
                        isMandatory: true,
                        acceptedFileTypes: [".pdf"]
                    }
                ]}
                customComponent={<AAutoComplete
                    label="Payment Type*"
                    placeholder="Select to add"
                    className='mb-1'
                    items={paymentModeDropdown}
                    currentValue={paymentType}
                    isMulti={false}
                    handleChange={(value) => {
                        setPaymentType(value)
                    }}
                />}
            />
        </div>
    );
}

export default UploadTransferFile;